module.exports = __webpack_public_path__ + "img/bombe.a2521b73.jpg";